import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "el-dropdown-link" }, [
  /*#__PURE__*/_createTextVNode(" Insert Placeholder "),
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-angle-down" })
], -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("No available placeholder")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createBlock(_component_el_dropdown, {
    trigger: "click",
    "max-height": 300,
    size: "small"
  }, {
    dropdown: _withCtx(() => [
      (_ctx.placeHolderOptions.length)
        ? (_openBlock(), _createBlock(_component_el_dropdown_menu, { key: 0 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.placeHolderOptions, (option, key) => {
                return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                  key: key,
                  onClick: ($event: any) => (_ctx.placeholderSelector(option))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(option), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_el_dropdown_menu, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, null, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ]),
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}